/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';
import { Popover } from 'antd';
import SocialShareIcons from 'Components/share/SocialShareIcons';
import ShareArticleIcon from 'Components/common/assets/svgIcons/ShareArticleIcon';

const Wrapper = styled.div``;

const ContentWrapper = styled.div`
  .shareIconsWrapper{
    .evernote-share-button,
    .social-icons-slide-mail,
    .social-icons-slide-linkedin,
    .social-icons-slide-twitter,
    .social-icons-slide-facebook,
    .teams-share-button{
      height: 20px !important;
      width: 20px;
    }
  }
`;

type Props = {
  articleId: number
  title: string
  img: string
  domain: string
  alertId?: number
  url?: string
  articleSummary: string[]
  summaryLoading: boolean
  summaryLoaded: boolean
};

const defaultProps = {
  alertId: 0,
  url: '',
};

const ArticleShareButton: React.FC<Props> = function ArticleShareButton({
  articleId, title, img, domain, alertId, url, articleSummary,
  summaryLoading, summaryLoaded,
}) {
  const content = (
    <ContentWrapper className="sharingPopoverContentWrapper">
      <h6 className="heading-popover">QuickShare to:</h6>
      <SocialShareIcons
        articleid={articleId}
        title={title}
        img={img}
        domain={domain}
        entity="article"
        alertId={alertId}
        url={url}
        summary={articleSummary}
        summaryLoading={summaryLoading}
        summaryLoaded={summaryLoaded}
      />
    </ContentWrapper>
  );

  return (
    <Wrapper>
      <Popover
        placement="right"
        content={content}
        trigger="click"
        getPopupContainer={(e: HTMLElement) => e}
        className="popover-sharing salesSigmaSharingPopover popoverSharingCustom popoverSharingListingView"
        arrow={false}
      >
        <div aria-hidden="true">
          <span className="d-none">share-icon</span>
          <ShareArticleIcon />
        </div>
      </Popover>
    </Wrapper>
  );
};

ArticleShareButton.defaultProps = defaultProps;
export default ArticleShareButton;
